import { useEffect, useState } from "react";
import { siteConfig } from "../data/mock";

const HeroSection = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      className="min-h-screen flex flex-col items-center justify-center px-6 relative"
    >
      {/* Category Tag */}
      <div
        className={`transform transition-all duration-700 delay-100 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        <span className="inline-block font-mono text-xs tracking-[0.3em] text-[#6B7280] border border-[#6B7280]/30 px-4 py-2 rounded-sm mb-8">
          {siteConfig.category}
        </span>
      </div>

      {/* Main Headline */}
      <h1
        className={`font-mono text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-center text-[#F3F4F6] tracking-tight leading-tight max-w-5xl transform transition-all duration-700 delay-200 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        {siteConfig.tagline}
      </h1>

      {/* Subtitle */}
      <p
        className={`font-sans text-lg md:text-xl text-[#6B7280] text-center max-w-2xl mt-8 leading-relaxed transform transition-all duration-700 delay-300 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        {siteConfig.subtitle}
      </p>

      {/* Scroll Indicator */}
      <div
        className={`absolute bottom-12 transform transition-all duration-700 delay-500 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          <span className="font-mono text-xs tracking-widest text-[#6B7280]">SCROLL</span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-[#00F0FF]/50 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
